import React, { useEffect } from 'react';
import { Hero } from '../components/sales/Hero';
import { StickyBar } from '../components/sales/StickyBar';
import { ProblemSection } from '../components/sales/ProblemSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { WhatYouGet } from '../components/sales/WhatYouGet';
import { Testimonials } from '../components/sales/Testimonials';
import { PriceSection } from '../components/sales/PriceSection';
import { FAQ } from '../components/sales/FAQ';
import { Footer } from '../components/sales/Footer';
import { SocialProofPopup } from '../components/sales/SocialProofPopup';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-body text-navy antialiased selection:bg-gold/30 pb-20 md:pb-0" data-id="element-216">
      <StickyBar data-id="element-217" />
      <Hero data-id="element-218" />
      <ProblemSection data-id="element-219" />
      <SolutionSection data-id="element-220" />
      <WhatYouGet data-id="element-221" />
      <Testimonials data-id="element-222" />
      <PriceSection data-id="element-223" />
      <FAQ data-id="element-224" />
      <Footer data-id="element-225" />
      <SocialProofPopup data-id="element-226" />
    </div>;
}